import type { DeleteConversationMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteConversationDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Flag-gated wrapper (RSP-6496). The compound delete (comments then the
 * conversation) returns `{ Id }` from both paths.
 */
export const useDeleteConversation = createMutationHook({
  name: 'deleteConversation',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.conversation.delete.mutationOptions({ onSuccess }),
  mapInput: (input: { Id: string }) => input,
  invalidate: (trpc) => [
    trpc.frontend.comment.commentsByConversationId.queryKey(),
  ],
  mapResponse: (result: { Id: string }): { Id: string } => ({
    Id: result.Id,
  }),
  graphqlDocument: DeleteConversationDocument,
  graphqlVariables: (input: { Id: string }) => ({ Id: input.Id }),
  // The Apollo response isn't consulted — the legacy wrapper always echoed
  // the input Id back rather than reading `delete_conversation_by_pk`.
  mapGraphqlResponse: (
    _data: DeleteConversationMutation,
    input: { Id: string }
  ): { Id: string } => ({ Id: input.Id }),
});
